import React, { useMemo, useState } from 'react'
import SearchFromTheList from '../../../../../../generic/customSearchComponents/SearchFromTheList'

type Props = {
  required?: boolean
  placeholder?: string
  disabled?: boolean
  selectedGroupBy: number
  setSelectedGroupBy: (value: number) => void | React.Dispatch<React.SetStateAction<number>>
}
/**
     * Group by:
     * 1 - ProblemType
     * 2 - Seller
     * 3 - Customer
     * 4 - Product
     */
const GROUP_BY_OPTIONS = [
  {id: 1, name: 'סוג פניה'},
  {id: 2, name: 'משווק'},
  {id: 3, name: 'לקוח'},
  {id: 4, name: 'פריט'},
]
const SearchReportGroup = ({
  selectedGroupBy,
  setSelectedGroupBy,
  required,
  placeholder,
  disabled,
}: Props) => {
  const defaultGroupBy = GROUP_BY_OPTIONS.find(item => item.id === selectedGroupBy)
  const [isOpenDropDown, setIsOpenDropDown] = useState<boolean>(false)
  const [inputGroupBy, setInputGroupBy] = useState<string>(defaultGroupBy?.name || '')
  const [selectedGroupByOption, setSelectedGroupByOption] = useState<{id: number, name: string} | null>(defaultGroupBy || null)
  const handleSearchGroupBy = (e: string) => {
    if(disabled) return
   
    if(e === '') {
      setSelectedGroupByOption(null)
      setSelectedGroupBy(0)
      setInputGroupBy('')
      setIsOpenDropDown(false)
      return
    }
    setIsOpenDropDown(true)
    setInputGroupBy(e)
  }
  const handleSelectGroupBy = (item: {id: number, name: string}) => {
    setSelectedGroupByOption(item)
    setSelectedGroupBy(item.id)
    setInputGroupBy(item.name)
    setIsOpenDropDown(false)
  } 
  const render = useMemo(() => {
    if(!GROUP_BY_OPTIONS) return []
    return GROUP_BY_OPTIONS.filter(item => item.name.trim().toLowerCase().includes(inputGroupBy.trim().toLowerCase()))
  }, [inputGroupBy, GROUP_BY_OPTIONS])
  return (
    <SearchFromTheList
      isOpenList={isOpenDropDown}
      placeHolder={placeholder || 'חפש סוג פניה'}
      list={render}
      selectFunc={handleSelectGroupBy}
      searchFunc={handleSearchGroupBy}
      isNeedFullObject
      input={inputGroupBy}
      itemDisplayName='name'
      nameIdElement='id'
      required={required}
      size={'full'}
      disabled={disabled}
    />
  )
}

export default SearchReportGroup

// reference

// const defaultPackage = list.filter(item => item.PackID === defaultID)[0]
// const [isOpenDropDown, setIsOpenDropDown] = useState<boolean>(false)
// const [selectedPackage, setSelectedPackage] = useState<IPackagesItem | null>(defaultPackage || null)
// const [search, setSearch] = useState<string>(defaultPackage?.Pack_Name.trim() || '')
// const handleSearch = (e: string) => {
//   if(e === '') {
//     setSelectedPackage(null)
//     setIsOpenDropDown(false)
//     setSearch('')
//     setPackageID(0)
//     return
//   }
//   setIsOpenDropDown(true)
//   setSearch(e)
// }
// const handleSelect = (item: IPackagesItem) => {
//   setSearch(item.Pack_Name.trim())
//   setSelectedPackage(item)
//   setIsOpenDropDown(false)
//   setPackageID(item.PackID)
// }
// const render = useMemo(() => {
//   if(!list) return []
//   return list.filter(item => 
//     item.Pack_Name.trim().toLocaleLowerCase().includes(search.toLocaleLowerCase())
//   )

// }, [search, list])
// useEffect(() => {
//   if(!defaultID) return
//   const found = list.find(item => item.PackID === defaultID)
//   if(!found) return
//   setSelectedPackage(found)
//   setSearch(found.Pack_Name.trim())
// }, [defaultID])
// return (
//   <SearchFromTheList 
//     isOpenList={isOpenDropDown}
//     placeHolder={placeholder || 'חפש סוג אריזה'}
//     list={render}
//     selectFunc={handleSelect}
//     searchFunc={handleSearch}
//     isNeedFullObject
//     input={search}
//     itemDisplayName='Pack_Name'
//     nameIdElement='PackID'
//     required={required}
//     size={'full'}
//   />
// )
// }

// export default SearchPackage